import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Content = styled.div`
  inset-inline: 0;

  display: flex;
  gap: 20px;
  justify-content: center;

  min-block-size: 100vh;
  margin-block-start: 24px;
  margin-inline: auto;
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1208px;
    padding-inline: 32px;
  }
`;
